/**
 * Islands and Stimulus controllers do not have React Router context available to them. When an
 * island or Stimulus controller is mounted within an EchoSlot, we want to take advantage of Echo's
 * navigation.
 *
 * Some of these islands are part of the Add Goal flow, which runs in a mobile webview that does
 * not implement native browser behavior, like form submission and `window.location.assign`. It's
 * especially important in these scenarios that React Router performs the navigation.
 */

type IslandNavigateDetail = { url: string };

declare global {
  interface GlobalEventHandlersEventMap {
    'island:navigate': CustomEvent<IslandNavigateDetail>;
  }
}

/**
 * @deprecated Islands are deprecated, and so is this function.
 */
export function dispatchIslandNavigate(url: string): void {
  const event = new CustomEvent<IslandNavigateDetail>('island:navigate', {
    cancelable: true,
    detail: { url },
  });

  if (document.dispatchEvent(event)) {
    throw new Error('The island:navigate event was not handled by <EchoRoute />');
  }
}
